import { 
    apiRequest,
    cutiUpdate
} from '../../../../../services/adapters/kepegawaian/cutiService'

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", cutiUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository